import i18n from '../i18n.js';

const LANGUAGE_TO_LOCALE: Readonly<Record<string, string>> = {
  ar: 'ar',
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  hi: 'hi',
  id: 'id',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  ms: 'ms',
  nl: 'nl',
  pt: 'pt',
  th: 'th',
  vi: 'vi',
  zh: 'zh',
};

/** Returns the BCP-47 locale tag for a given i18next language code. */
export function resolveLocale(language: string): string {
  return LANGUAGE_TO_LOCALE[language] ?? language;
}

/** Returns the BCP-47 locale for the currently resolved i18next language. */
export function getCurrentLocale(): string {
  // i18next can return an empty string before it resolves a language,
  // so a falsy check is intentional here.
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  return resolveLocale(i18n.resolvedLanguage || i18n.language || 'en');
}
